import { render, staticRenderFns } from "./CapabilityRatingsCpt.vue?vue&type=template&id=78f934ea&scoped=true&"
import script from "./CapabilityRatingsCpt.vue?vue&type=script&lang=ts&"
export * from "./CapabilityRatingsCpt.vue?vue&type=script&lang=ts&"
import style0 from "./CapabilityRatingsCpt.vue?vue&type=style&index=0&id=78f934ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f934ea",
  null
  
)

export default component.exports